import React, { useEffect, useState } from 'react';

import { useCookies } from 'react-cookie';

import { toast } from 'react-toastify';

import DashboardContext from './index';

const ProviderContext = ({ children }) => {
  const [cookies, , removeCookie] = useCookies(['Authentication']);
  /**این متغییر برای دریافت لیست منو سایذ بار استفاده می شود */
  const [sideBardata, setSideBardata] = useState(
    JSON.parse(localStorage.getItem('sidebar')) || ''
  );

  /**این تابع مقدار ساید بار در زمان لاگین در یافت می کندو در لوکال استوریج ذخیر می کند */
  const handelsidebar = (item) => {
    setSideBardata(item);
    localStorage.setItem('sidebar', JSON.stringify(item));
  };
  /**وظیفه متغییر نمایش لودینگ است */
  const [loding, setLoding] = useState(false);
  /**آرایه دسترسی های صفحه کاربر است */
  const [accessPage, setAccessPage] = useState([]);
  /**ادرس صفحه کاربر */
  const [urlpage, setUrlpage] = useState('');
  /**عنوان فارسی صفحه */
  const [titlePage, settitlePage] = useState('');
  /**دسته بندی صفحه */
  const [categorypage, setCategorypage] = useState('');
  /**وظیفه این تابع دریافت ادرس و تظیم متغییر ها است */
  const handelAccessPage = (controller) => {
    if (sideBardata) {
      sideBardata?.map((item) => {
        item.controllers.filter((find) => {
          if (`/${find.controller}` === controller) {
            setAccessPage(find.actions);
            setUrlpage(controller);
            setCategorypage(item.category.trim().replace(/ /g, '-'));
            settitlePage(find.controllerTitle);
            return find;
          }
        });
      });
    }
  };

  /**این متغییر برای دریافت ایدی ایتم در حال ویرایش است */
  const [edit, setEdit] = useState(
    JSON.parse(sessionStorage.getItem('itemedit')) || ''
  );
  /**این تابع برای دریافت و ایدی ویرایش و ذخیر اند در سیشن است */
  const handelEdit = (id) => {
    sessionStorage.setItem('itemedit', JSON.stringify(id));
    setEdit(id);
  };
  /**نمایش فرم افزودن در صفحه را مدیریت می کند */
  const [SohwaddFrom, setSohwaddFrom] = useState(
    JSON.parse(sessionStorage.getItem('showfrom')) || false
  );
  const [changeNumber, setChangeNumber] = useState(
    JSON.parse(sessionStorage.getItem('changeNumber')) || false
  );
  /**این تابع فرم افزودن و ذخیر در سیشن را انجام می دهد */
  const handelAdd = (status) => {
    sessionStorage.setItem('showfrom', JSON.stringify(status));
    setSohwaddFrom(status);
  };
  const HandlechangeNumber = (status) => {
    sessionStorage.setItem('changeNumber', JSON.stringify(status));
    setChangeNumber(status);
  };
  const [urlPatch, setUrlPatch] = useState('');
  const handelPatch = (item) => setUrlPatch(item);
  /**نام و نام خانوادگی کاربر که در هنگام ورود داده می شود */
  const [userName, setUserName] = useState(
    JSON.parse(localStorage.getItem('username')) || ''
  );
  /**ایدی موردی برای نمایش کلیک شده */
  const [idview, setIdview] = useState(
    JSON.parse(sessionStorage.getItem('idview')) || ''
  );
  /**وقتی قرار فرم در جاهای کوچیک به نمایش در بیاد استفاده میشه
   * یعنی مثل فرم کلی نیست و فقط میخوایم یک بخش عوض بهش مثل در پروفایل ها
   */
  const [showformmicro, setShowformmicro] = useState(
    JSON.parse(sessionStorage.getItem('microFrom')) || false
  );

  const [idshowitem, setIdshowitem] = useState(
    JSON.parse(sessionStorage.getItem('idshowitem')) || ''
  );

  const handelidshowitem = (id) => {
    sessionStorage.setItem('idshowitem', JSON.stringify(id));
    setIdshowitem(id);
  };

  const handeldmicro = (item) => {
    sessionStorage.setItem('microFrom', JSON.stringify(item));
    setShowformmicro(item);
  };

  const [Workername, setWorkername] = useState('');
  const handelworkername = (name) => setWorkername(name);

  const [dataFromTabel, setDataFromTabel] = useState({});

  const handelFromTabel = (item) => setDataFromTabel(item);

  /**توکن که در کوکی ذخیره شده است میگیرد */
  const [authentication, setAuthentication] = useState(
    cookies.Authentication || ''
  );
  /**شماره موبایل کاربر */
  const [userCellPhone, setUserCellPhone] = useState(
    JSON.parse(localStorage.getItem('CellPhone')) || ''
  );
  /**نشان دهنده این است که آیا کاربر لاگین هست یا خیر */
  const [islogin, setIslogin] = useState(
    cookies.Authentication && userName && userCellPhone ? true : false
  );

  /**این تابع در هنگام لاگین کاربر نام کاربر می گیرد و در لوکال استوریج می ریزد */
  const handelusername = (username) => {
    setUserName(username);
    localStorage.setItem('username', JSON.stringify(username));
  };
  /**برای ثبت تغغیر در وضعیت لاگین کاربر است */
  const handelLogin = (item) => setIslogin(item);
  /**دریافت تغییر در وضعیت توکن کاربر است */
  const handelAuthentication = (authen) => setAuthentication(authen);

  /**این تابع شماره تلفن کاربر را در هنگام ورودر میگیرد و در لوکال استوریج می ریزد */
  const handelUserCellPhone = (item) => {
    setUserCellPhone(item);
    localStorage.setItem('CellPhone', JSON.stringify(item));
  };

  const handelloding = (item) => setLoding(item);

  const handelIdview = (item) => {
    sessionStorage.setItem('idview', JSON.stringify(item));
    setIdview(item);
  };
  const [idCustomer, setIdCustomer] = useState(
    JSON.parse(localStorage.getItem('customerid')) || ''
  );

  const handelIdCustomer = (id) => {
    localStorage.setItem('customerid', JSON.stringify(id));
    setIdCustomer(id);
  };

  const handelerrors = (error) => {
    if (error?.message === 'Network Error') {
      toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      if (error?.response?.status === 401) {
        handelLogin(false);
        localStorage.clear();
        sessionStorage.clear();
        removeCookie('Authentication');
        toast.error('خطا در اهراز هویت لطفا مجددا وار شوید', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      toast.error(error?.response?.data?.message, {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { width: 1000 },
      });
      if (error?.response?.data?.errors) {
        error?.response?.data?.errors.map((item) => {
          toast.error(item.title, {
            position: 'bottom-left',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      }
    }
  };

  const [walletupdate, setWalletupdate] = useState(false);

  const handelWalletupdate = () => setWalletupdate(!walletupdate);

  const [searchLoading, setSearchLoading] = useState(false);

  const [newPeriodTime, setNewPeriodTime] = useState(0);

  const [orderLoader, setorderLoader] = useState(false);

  const setOffSearchLoding = () => setSearchLoading(false);
  const setOnSearchLoading = () => setSearchLoading(true);

  const [showEditOrder, setShowEditOrder] = useState(false);

  const handelEditOrder = (status) => {
    setShowEditOrder(status);
  };

  const envirement = 'pro';

  const productionEnvCheck = envirement === 'pro';

  return (
    <DashboardContext.Provider
      value={{
        setOffSearchLoding,
        setOnSearchLoading,
        searchLoading,
        setorderLoader,
        orderLoader,
        setNewPeriodTime,
        newPeriodTime,
        changeNumber,
        HandlechangeNumber,
        sideBardata,
        handelsidebar,
        handelAccessPage,
        accessPage,
        setAccessPage,
        edit,
        handelEdit,
        SohwaddFrom,
        handelAdd,
        urlPatch,
        handelPatch,
        urlpage,
        titlePage,
        islogin,
        userName,
        authentication,
        userCellPhone,
        // urldashboard: 'https://localhost:44383/api/v1',
        urldashboard: productionEnvCheck
          ? 'https://crmapigateway.serviq.net/api/v1'
          : 'https://testcrmapigateway.serviq.net/api/v1',

        urlHcm: productionEnvCheck
          ? 'https://crmapigateway.serviq.net/api/dashboard'
          : 'https://testcrmapigateway.serviq.net/api/dashboard',

        notificationUrl: productionEnvCheck
          ? 'https://crmapigateway.serviq.net'
          : 'https://testcrmapigateway.serviq.net',

        isonline: window.navigator.onLine,
        loding,
        handelusername,
        handelLogin,
        handelAuthentication,
        handelUserCellPhone,
        handelloding,
        idview,
        handelIdview,
        showformmicro,
        handeldmicro,
        handelworkername,
        Workername,
        dataFromTabel,
        handelFromTabel,
        idshowitem,
        handelidshowitem,
        idCustomer,
        handelIdCustomer,
        handelerrors,
        walletupdate,
        handelWalletupdate,
        showEditOrder,
        handelEditOrder,
        categorypage,
        envirement,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default ProviderContext;
